import { EllipsisText, type GridColDef } from '@shared/components';

import { ExtendedDurationCell } from '../extended-duration-cell';

import { type TimeExtensionHistoryRow } from './types';

export const columns: GridColDef<TimeExtensionHistoryRow>[] = [
  {
    field: 'seatNumber',
    headerName: 'เลขที่นั่ง',
    width: 78,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: ({ value }) => value ?? '-',
  },
  {
    field: 'fullName',
    headerName: 'ชื่อ - นามสกุล',
    minWidth: 280,
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => <EllipsisText>{`${row.firstName} ${row.lastName}`}</EllipsisText>,
  },
  {
    field: 'examCourseCode',
    headerName: 'หลักสูตร',
    width: 120,
    sortable: false,
  },
  {
    field: 'manualExtendedDurationInMs',
    headerName: 'ทดโดยผู้คุม',
    width: 110,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
    renderCell: ({ value }) => <ExtendedDurationCell value={value} />,
  },
  {
    field: 'autoExtendedDurationInMs',
    headerName: 'ทดโดยระบบ',
    width: 110,
    sortable: false,
    align: 'right',
    headerAlign: 'right',
    renderCell: ({ value }) => <ExtendedDurationCell value={value} />,
  },
  {
    field: 'remark',
    headerName: 'เหตุผล (ทดรายคน)',
    minWidth: 280,
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => <EllipsisText>{row.remark}</EllipsisText>,
  },
];
